export const I18n = {
    'en': {
        name: 'Name of the advertising campaign',
        appLabel: 'Name of the application',
        chooseAppIcon: 'Choose an icon for application',
        countries: 'Select countries to target',
        cities: 'Select cities',
        retailers: 'Select retailers',
        reward: 'Reward',
        payoutModel: 'Payout model',
        payoutCondition: 'Condition of payout',
        rewardLimit: 'Advertising campaign reward limit',
        dateStart: 'Start date of the advertising campaign',
        dateFinish: 'End date of the advertising campaign',
        redirectUrlType: "Referral link type",
        redirectUrl: 'Referral link',
        partnerSiteUrl: 'Partner site',
        dateFrom: 'From date',
        dateTo: 'To date',
        cancel: 'Cancel',
        save: 'Save',
        update: 'Update',
        status: 'Status',
        start: 'Start',
        stop: 'Stop',
        close: 'Close',
        offerDraft: 'Draft',
        offerActive: 'Active',
        offerCanceled: 'Canceled',
        reset: 'Reset',

        //errors
        offerTitleAlreadyExists: 'Advertising campaign with current name already exists',
        limitCanNotBeLowerThanReward: 'Reward limit can not be lower than reward',
        limitOrEndDateShouldBeFilled: 'Reward limit or end date must be filled',
        titleValidationRules: 'Name of the advertising campaign can only contain latin letters, numbers, dots, hyphens and underscores',
        iconIsTooBig: 'The icon is too large',
        isNotAnIcon: 'Selected file isn\'t an icon',
        canNotBeNull: 'Can not be null',
        smthWentWrong: 'Something went wrong. Try later',
    },
    'ru': {
        offerTitle: 'Создание оффера',
        name: 'Название рекламной кампании',
        appLabel: 'Название приложения',
        chooseAppIcon: 'Выберите иконку для приложения',
        countries: 'Выберите страны для таргетинга',
        cities: 'Выберите города',
        retailers: 'Выберите торговые сети',
        reward: 'Вознаграждение',
        payoutModel: 'Модель выплат',
        payoutCondition: 'Условие по выплате',
        rewardLimit: 'Лимит вознаграждения по рекламной кампании',
        dateStart: 'Дата начала рекламной кампании',
        dateFinish: 'Дата окончания рекламной кампании',
        redirectUrlType: "Тип реферальной ссылки",
        redirectUrl: 'Реферальная ссылка',
        partnerSiteUrl: 'Сайт партнера',
        dateFrom: 'C даты',
        dateTo: 'По дату',
        cancel: 'Отмена',
        save: 'Сохранить',
        update: 'Обновить',
        status: 'Статус',
        start: 'Запуск',
        stop: 'Остановить',
        close: 'Закрыть',
        offerDraft: 'Драфт',
        offerActive: 'Активный',
        offerCanceled: 'Отменен',
        reset: 'Сбросить',

        //errors
        offerTitleAlreadyExists: 'Рекламная кампания с данным именем уже существует',
        limitCanNotBeLowerThanReward: 'Лимит по рекламной компании не может быть ниже вознагрождения',
        limitOrEndDateShouldBeFilled: 'Дата окончания или лимит по рекламной компании должны быть указаны',
        titleValidationRules: 'Название рекламной кампании может содержать только латинские буквы, цифры, точки, дефисы и нижнее подчеркивание',
        iconIsTooBig: 'Иконка слишком большого размера',
        isNotAnIcon: 'Выбранный файл не является иконкой',
        canNotBeNull: 'Не может быть нулевым',
        smthWentWrong: 'Что-то пошло не так. Попробуйте попытку позже',
    },
    'sk': {
        offerTitle: 'Ponuka',
        email: 'E-mail',
        phone: 'Telefón',
        name: 'Názov',
        type: 'Typ',
        country: 'Krajina',
        city: 'Veľkomesto',
        manager: 'Manažér',
        skype: 'Skype',
        statusPending: 'Nevykonaného',
        statusBlocked: 'Upchatý',
        statusActive: 'Aktívny',
        noStatus: 'Nikto',
        defaultPasswd: 'Predvolené heslo',
        cancel: 'Zrušiť',
        save: 'Uložiť',
        status: 'Postavenie',
        offerDraft: 'Draft',
        offerActive: 'Aktívny'
    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/offer/index.js